// extracted by mini-css-extract-plugin
export default {"container":"viewTenant_container__aprch","content":"viewTenant_content__aOgTD"};